import React from 'react';
import {ChipField, ReferenceField, TabbedShowLayout, TextField} from 'react-admin';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import {propertyRowStyle} from "../../tools_property_row_style";
import {d4UrlSchema} from "../../Env";
import {renderDateField, renderIfExists, renderProperties, renderReferenceField} from '../../d4tools_tab';

function D4ProdTabProduct(props, controllerProps) {
    const {record} = controllerProps;

    // Check if the component should be rendered
    const shouldRender = record &&
        record['@context'] &&
        JSON.stringify(Object.values(record['@context'])).includes(`${d4UrlSchema}/product.json`);

    if (!shouldRender) return null;

    return (
        <TabbedShowLayout.Tab label="Product" icon={<DeveloperBoardIcon/>}>
            <TextField label="Name" source="product:objName"/>
            {renderIfExists(record, "product:description",
                <TextField label="Description" source="product:description"/>
            )}
            {renderReferenceField(record, "product:hasPart", "products", "Has Part", props)}
            {renderIfExists(record, "product:isPartOf",
                <ReferenceField label="Is Part Of" source="product:isPartOf" reference="products">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderIfExists(record, "product:containedIn",
                <ReferenceField label="Contained In" source="product:containedIn" reference="locations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderReferenceField(record, "product:providesFunction", "functions", "Provides Function", props)}
            {renderIfExists(record, "product:long_desc", <TextField source="product:long_desc"/>)}
            {renderIfExists(record, "product:vendor", <TextField label="Vendor" source="product:vendor"/>)}
            {renderIfExists(record, "product:manufacturer", <TextField label="Manufacturer"
                                                                       source="product:manufacturer"/>)}
            {renderIfExists(record, "product:serial_number", <TextField label="Serial number"
                                                                        source="product:serial_number"/>)}
            {renderIfExists(record, "product:uid", <TextField label="Product UID" source="product:uid"/>)}
            {renderIfExists(record, "product:responsibleOrganisation",
                <ReferenceField label="Responsible Organisation" source="product:responsibleOrganisation"
                                reference="organisations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderIfExists(record, "product:tags", <TextField source="product:tags"/>)}
            {renderReferenceField(record, "product:tags", "tags", "Tags", props)}
            {renderProperties(record, "product:properties", propertyRowStyle)}
            {renderDateField(record, "product:created", "Created")}
            {renderDateField(record, "product:modified", "Modified")}
            {renderDateField(record, "product:expired", "Expired")}
        </TabbedShowLayout.Tab>
    );
}

export default D4ProdTabProduct;
